import { Images } from '@microfrontends/react-components'
import Link from 'next/link'
import { useContext } from 'react'
import AppContext from '../../context/AppContext'
import { GoToNumerologyCss } from './index.css'

export default function GoToNumerology() {
	const { t } = useContext(AppContext)
	return (
		<GoToNumerologyCss>
			<Link href={t('/numerology')}>
				<a>
					<Images.ArrowDownIcon />
					<span>Về trang nhân số học</span>
				</a>
			</Link>
		</GoToNumerologyCss>
	)
}
